const date = new Date()
const firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)

function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}

const filtriMovimenti = {
    state: {
        filters: {
            from: formatDate(firstDay),
            to: formatDate(lastDay),
            kind: null,
            category_id: null
        }
    },
    mutations: {
        SET_FILTRI_MOVIMENTI_FROM(state, payload) {
            state.filters.from = payload
        },
        SET_FILTRI_MOVIMENTI_TO(state, payload) {
            state.filters.to = payload
        },
        SET_FILTRI_MOVIMENTI_KIND(state, payload) {
            state.filters.kind = payload
        },
        SET_FILTRI_MOVIMENTI_CATEGORY_ID(state, payload) {
            state.filters.category_id = payload
        },
        RESET_FILTRI_MOVIMENTI(state) {
            state.filters = {
                from: formatDate(firstDay),
                to: formatDate(lastDay),
                kind: null,
                category_id: null
            }
        }
    },
    getters: {
        getFiltriMovimenti: state => state.filters,
    }
}

export default filtriMovimenti